export const DATADOME_TAGS = 'https://dd.perfectgift.com/tags.js'

export const DATADOME_JS = 'https://api-js.datadome.co/js/'
